
import { greekSearchFilter } from "@/helpers/data";
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, appointmentsModule, appointmentsRecurrencesModule } from '@/store/modules/store-accessor'
import { calcDuration } from '@/helpers/data';

@Component
export default class CancelAppointmentModal extends Vue {
  greekSearchFilter = greekSearchFilter;
  @Prop()
  payload!: any;

  isCancelingAppointment = false;
  showCancelNotes = false;
  cancelReasonCombo: AppointmentCancelReasonComboDto | null = null;

  appointmentModel = {
    id: this.payload.appointment.id,
    appointment_cancel_reason_id: '',
    appointment_cancel_notes: '',
    installation_id: this.payload.appointment.installation_id,
  };

  cancelNotesRule = [
    (val: any) => {
      if (val.length > 100) {
        return this.$i18n.t('cancelAppointmentReasonNotesLimit');
      }

      return true;
    },
  ];

  cancelReasonRule = [
    (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t('cancelReasonRequired'),
  ]

  cancelReasonUpdate() {
    if(this.cancelReasonCombo?.id === 5) {
      this.showCancelNotes = true;
    } else {
      this.showCancelNotes = false;
      this.appointmentModel.appointment_cancel_notes = '';
    }
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.getDurationCombo();
    commonModule.initSnackbar({});
  }

  get appointmentCancelReasonsCombo() {
    return commonModule.appointmentsCancelReasonsCombo;
  }

  get durationCombo() {
    return commonModule.durationCombo;
  }

  doDelete() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.isCancelingAppointment = true;
      this.appointmentModel.appointment_cancel_reason_id = String(this.cancelReasonCombo?.id || '');

      if (this.payload.appointment.is_virtual) {
        const appointment = this.payload.appointment;
        const assignee = appointment.assignees?.[0] ?? null;
        const editAppointmentData = {
          custom_appointment_data: {
            ...appointment,
            assignee,
            assignee_id: assignee?.id ?? null,
            assignee_ids: appointment.assignees ?? [],
            duration: { dur: this.durationFound(calcDuration(this.payload.appointment.scheduled_start, this.payload.appointment.scheduled_end)) },
            appointment_cancel_reason_id: this.appointmentModel.appointment_cancel_reason_id,
            appointment_cancel_notes: this.appointmentModel.appointment_cancel_notes,
          },
          exception_date: appointment.scheduled_start,
          notes: appointment.appointment_notes,
          appointment_status_id: 1, // Cancelled
          recurrence_id: appointment.recurrence_id,
          send_client_email: false,
        };

        appointmentsRecurrencesModule.createAppointmentRecurrenceExceptionAction(editAppointmentData);
      } else { // Real appointment
        appointmentsModule.cancelAppointment(this.appointmentModel);
      }

      this.hideModal();
    }
  }

  durationFound(duration: string) {
    const found: any = commonModule.durationCombo?.find((item: any) => {
      return item.text === duration;
    });
    return found == undefined ? '' : found.dur;
  }

};
